<div class="confirm-modal ig-modal edit-tour-title-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <mat-icon class="main-icon">edit</mat-icon>
    <h3>Edit Tour</h3>

    <div class="nav-approve-wrap">
        <form ngForm="editTourTitleFormGroup" class="search-wrap">
            <ig-mat-field label="Tour Title"
                          [(ngModel)]="data.title"
                          [formControl]="editTourTitleFormGroup.get('title')">
            </ig-mat-field>

            <ig-mat-field label="Tour Description"
                          [(ngModel)]="data.description"
                          [formControl]="editTourTitleFormGroup.get('description')">
            </ig-mat-field>
        </form>
    </div>

    <ig-row [pinCenter]="true">
        <ig-col [xs]="6">
            <ig-button class="btn-primary" #confirmButton color="primary" size="md"
                       [isAsync]="data.isAsync"
                       (trigger)="confirm($event)">
                OK
            </ig-button>
        </ig-col>
    </ig-row>
    <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
        Cancel
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/edit.tour.title.modal/edit.tour.title.modal.component.html